const FLOW_SPLITS = {
  webPermanentDiscount: 'web_permanent_discount',
} as const

const SERVER_SPLITS = {
  webPetHealthV2: 'web_pet_health_v2',
} as const

export const SPLIT_NAMES = { ...FLOW_SPLITS, ...SERVER_SPLITS } as const

export type SplitName = (typeof SPLIT_NAMES)[keyof typeof SPLIT_NAMES]

export type SplitTreatments = Partial<Record<SplitName, string>>

export const FLOW_SPLIT_NAMES: readonly SplitName[] = Object.values(FLOW_SPLITS)
